// Table columns configuration
export const tableColumns = [
  "Sr. No",
  "Updated By",
  "Txn Type",
  "Mode",
  "Date",
  "Status",
  "Updated Amount",
  "Txn Amount",
];

// Get badge class based on transaction type
export const getTypeBadgeClass = (type) => {
  const typeMap = {
    credit: "amounts-table__type--credit",
    debit: "amounts-table__type--debit",
  };
  return typeMap[type?.toLowerCase()] || "";
};

// Get badge class based on status
export const getStatusBadgeClass = (status) => {
  const statusMap = {
    completed: "amounts-table__status--completed",
    pending: "amounts-table__status--pending",
    failed: "amounts-table__status--failed",
  };
  return statusMap[status?.toLowerCase()] || "";
};
